import React from "react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import { exploreLinks, links } from "./constants";
import Button, { BTN_VARIANTS } from "../Button";
import ChevronDownIcon from "../../assets/icons/ChevronDown.icon";

const ExploreNav = () => {
  const navTo = (href) => {
    window.open(href);
  };
  return (
    <section className={styles.explore}>
      <Button
        variant={BTN_VARIANTS.transparent}
        className={styles["explore-btn"]}
      >
        <span>Explore</span>
        <ChevronDownIcon width="24px" height="24px" />
      </Button>
      <section className={styles.links}>
        {exploreLinks.map((l) => {
          return (
            <Button
              key={l.href}
              variant={BTN_VARIANTS.transparent}
              onClick={() => navTo(l.href)}
              className={styles.btn}
            >
              <span>{l.title}</span>
            </Button>
          );
        })}
      </section>
    </section>
  );
};

const NavLinks = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.root}>
      <section className={styles.nav}>
        {links.map((link) => {
          if (link.external) {
            return (
              <Button
                key={link.href}
                variant={BTN_VARIANTS.transparent}
                onClick={() => window.open(link.href)}
                className={styles.btn}
              >
                <span>{link.title}</span>
              </Button>
            );
          }
          return (
            <Button
              key={link.href}
              variant={BTN_VARIANTS.transparent}
              onClick={() => navigate(link.href)}
              className={styles.btn}
            >
              <span>{link.title}</span>
            </Button>
          );
        })}
      </section>
      <ExploreNav />
      <Button
        variant={BTN_VARIANTS.primary}
        onClick={() => navigate("/dapps")}
        className={styles.download}
      >
        <span>Download dVPN</span>
      </Button>
    </div>
  );
};

export default NavLinks;
